export const businessRouteNames = {
  default: 'business-v2',
}
